import { fetchEndpoint } from "../network";
export default {
  // 创建
  imageDump(params) {
    return fetchEndpoint("/upload/dump", "POST", params);
  },
};
